import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import PropTypes from "prop-types";
import MaterialTypography from "../../MaterialTypography";
import MaterialBox from "../../MaterialBox";
import MaterialButton from "../../MaterialButton";
import "./index.css";

const ConfirmationDialog = ({
  open,
  showCancel,
  showConfirm,
  onConfirm,
  onCancel,
  title,
  message,
  customSection,
  done,
  back,
  pending = false,
  ...rest
}) => {
  return (
    <Dialog
      maxWidth="sm"
      // sx={pending ? { background: "black", backdropFilter: "blur(20)" } : {}}
      className={pending?"backdrop":""}
      fullWidth
      {...rest}
      open={open}
    >
      {!pending && (
        <>
          {" "}
          <DialogTitle>
            <MaterialTypography variant="h4"  fontWeight="bold" >{title}</MaterialTypography>
          </DialogTitle>
          <DialogContent variant="body2">
            {message}
            {customSection && <MaterialBox mt={2}>{customSection}</MaterialBox>}
          </DialogContent>
          <DialogActions>
            {showCancel && (
              <MaterialButton color="error" fontWeight="bold" variant="text" onClick={onCancel}>
                {back || "Cancel"}
              </MaterialButton>
            )}
            {showConfirm && (
              <MaterialButton color="dark" fontWeight="bold" variant="text" onClick={onConfirm}>
                {done || "Confirm"}
              </MaterialButton>
            )}
          </DialogActions>{" "}
        </>
      )}
      {pending && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
            backgroundColor: "transparent !important",
          }}
        >
          <div class="custom-loader"></div>
        </div>
      )}
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  showCancel: PropTypes.bool,
  showConfirm: PropTypes.bool,
  customSection: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  pending: PropTypes.bool,
};

export default ConfirmationDialog;
